import './CoursesInfoCard.scss';
import { cn } from '@helpers/styles';

export default function CoursesInfoCard({
  image,
  content,
  reverse = false,
  hideImageOnMobile = false
}) {
  return (
    <section
      className={cn('coursesInfoCard', {
        'coursesInfoCard-reverse': reverse,
        'coursesInfoCard-hide-image-mobile': hideImageOnMobile
      })}
    >
      <div className="coursesInfoCard-content">{content}</div>
      <div className="coursesInfoCard-image">{image}</div>
    </section>
  );
}
